/**
 * Coerce Mongo-style ids from API JSON (string, $oid, or invalid object) to a 24-char hex string when possible.
 */
export function normalizeMongoIdString(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string') {
    const t = value.trim();
    if (t === '[object Object]') return '';
    return t;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }
  if (typeof value === 'object' && value !== null && '$oid' in value) {
    const oid = (value as { $oid: unknown }).$oid;
    return typeof oid === 'string' ? oid.trim() : '';
  }
  return '';
}
